var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pos-topbar" }, [
    _c("div", { staticClass: "bar-left" }, [
      _c("span", { staticClass: "brand" }, [_vm._v("零售收银台")]),
      _c(
        "span",
        { staticClass: "cashier" },
        [
          _c("a-icon", { attrs: { type: "user" } }),
          _vm._v(" " + _vm._s(_vm.cashierName)),
        ],
        1
      ),
      _c("span", { staticClass: "clock" }, [_vm._v(_vm._s(_vm.clock))]),
    ]),
    _c("div", { staticClass: "bar-right" }, [
      _c("span", {
        staticClass: "net-dot",
        class: _vm.online ? "on" : "off",
        attrs: { title: _vm.online ? "网络正常" : "网络已断开" },
      }),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          on: {
            click: function ($event) {
              return _vm.$emit("hang")
            },
          },
        },
        [_vm._v("挂单"), _c("span", { staticClass: "key" }, [_vm._v("F2")])]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          on: {
            click: function ($event) {
              return _vm.$emit("take")
            },
          },
        },
        [_vm._v("取单"), _c("span", { staticClass: "key" }, [_vm._v("F3")])]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          on: {
            click: function ($event) {
              return _vm.$emit("return")
            },
          },
        },
        [_vm._v("退货"), _c("span", { staticClass: "key" }, [_vm._v("F4")])]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          on: {
            click: function ($event) {
              return _vm.$emit("shift")
            },
          },
        },
        [_vm._v("交班"), _c("span", { staticClass: "key" }, [_vm._v("F12")])]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          on: {
            click: function ($event) {
              return _vm.$emit("lock")
            },
          },
        },
        [_vm._v("锁屏"), _c("span", { staticClass: "key" }, [_vm._v("F1")])]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          attrs: { title: "打开顾客副屏（窗口复用，再次点击不重复开）" },
          on: {
            click: function ($event) {
              return _vm.$emit("screen")
            },
          },
        },
        [_vm._v("副屏")]
      ),
      _c(
        "div",
        {
          staticClass: "tool-pill",
          attrs: { title: "独立全屏窗口" },
          on: { click: _vm.openPos },
        },
        [_vm._v("独立窗口")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }